import { render, staticRenderFns } from "./MyKepuXuanJiaoMainPage.vue?vue&type=template&id=61246413&scoped=true"
import script from "./MyKepuXuanJiaoMainPage.vue?vue&type=script&lang=js"
export * from "./MyKepuXuanJiaoMainPage.vue?vue&type=script&lang=js"
import style0 from "./MyKepuXuanJiaoMainPage.vue?vue&type=style&index=0&id=61246413&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61246413",
  null
  
)

export default component.exports